export const FORM_URLS = {
  contact: 'https://readdy.ai/api/form/d9pha6hn2trhb35gvfbg',
};